import { Divider, Popover, Typography } from 'antd';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppInfoIcon } from 'shared/UI/UIKit/icons/Info';
import { AppTable } from 'shared/UI/UIKit/Table';
import { useDifficultyDistributionModelInfo } from 'features/schedule-configuration/model/hooks';
import styles from './DifficultyDistributionModelInfo.module.scss';

export const DifficultyDistributionModelInfo = () => {
  const {
    state: {
      fiveDayColumns,
      sixDayColumns,
      fiveDayHillDataSource,
      fiveDaySnakeDataSource,
      sixDayHillDataSource,
      sixDaySnakeDataSource,
    },
  } = useDifficultyDistributionModelInfo();

  const content = (
    <AppFlex direction="column" unit="16">
      <Typography.Text strong>
        Распределение трудности учебных предметов по дням недели при 5-дневной неделе, %
      </Typography.Text>
      <Typography.Text>Горка</Typography.Text>
      <AppTable
        dataSource={fiveDayHillDataSource}
        columns={fiveDayColumns}
        size="small"
        bordered
        rowKey={(record: { id: number }) => record.id}
        className={styles.table}
      />
      <Typography.Text>Змейка</Typography.Text>
      <AppTable
        dataSource={fiveDaySnakeDataSource}
        columns={fiveDayColumns}
        size="small"
        bordered
        rowKey={(record: { id: number }) => record.id}
        className={styles.table}
      />
      <Divider />
      <Typography.Text strong>
        Распределение трудности учебных предметов по дням недели при 6-дневной неделе, %
      </Typography.Text>
      <Typography.Text>Горка</Typography.Text>
      <AppTable
        dataSource={sixDayHillDataSource}
        columns={sixDayColumns}
        size="small"
        bordered
        rowKey={(record: { id: number }) => record.id}
        className={styles.table}
      />
      <Typography.Text>Змейка</Typography.Text>
      <AppTable
        dataSource={sixDaySnakeDataSource}
        columns={sixDayColumns}
        size="small"
        bordered
        rowKey={(record: { id: number }) => record.id}
        className={styles.table}
      />
    </AppFlex>
  );

  return (
    <AppFlex direction="row" alignItems="center" unit="8">
      <Typography.Text>Модель распределения учебной нагрузки</Typography.Text>
      <Popover trigger="click" content={content} placement="top">
        <AppInfoIcon style={{ cursor: 'pointer' }} />
      </Popover>
    </AppFlex>
  );
};
